import { useState, useEffect } from 'react';
import { IBusinessUnit, getBusinessUnitsByUserId } from 'wisestep-api';

//Added since BusinessUnitContext was causing a crash.
const useBusinessUnits = () => {
  const [buList, setBUList] = useState<IBusinessUnit[]>([]);
  const [isLoaded, setIsLoded] = useState(false);

  useEffect(() => {
    (async function () {
      if (!isLoaded) {
        try {
          const businessUnitsList = await getBusinessUnitsByUserId();

          setBUList(
            businessUnitsList.data.map((bu: IBusinessUnit) => ({
              id: bu.id,
              name: bu.name,
              active: bu.active,
              workspaceId: bu.workspaceId,
              createdBy: bu.createdBy,
              createdOn: bu.createdOn,
              modifiedBy: bu.modifiedBy,
              modifiedOn: bu.modifiedOn,
              description: bu.description,
            }))
          );
          setIsLoded(true);
        } catch {
          setBUList([]);
          setIsLoded(true);
        }
      }
    })();
  }, [isLoaded]);

  return buList;
};

export default useBusinessUnits;
